<template>
  <div class="admin-home">
    <!-- 用户情况（原版三卡） -->
    <el-row :gutter="20">
      <el-col :lg="8">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <span class="label label-success pull-right">数量</span>
            <h5>用户总数</h5>
          </div>
          <div class="ibox-content">
            <div class="big-num no-margins">{{ d.users_total }}</div>
            <small class="text-muted">用户数</small>
          </div>
        </div>
      </el-col>
      <el-col :lg="8">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <span class="label label-info pull-right">已使用系统</span>
            <h5>付费用户</h5>
          </div>
          <div class="ibox-content">
            <div class="big-num no-margins">{{ d.users_vip }}</div>
            <small class="text-muted">总计VIP数</small>
          </div>
        </div>
      </el-col>
      <el-col :lg="8">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <span class="label label-info pull-right">未使用系统</span>
            <h5>未付费用户</h5>
          </div>
          <div class="ibox-content">
            <div class="big-num no-margins">{{ d.users_normal }}</div>
            <small class="text-muted">总计非VIP数</small>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 任务情况 -->
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <span class="label label-primary pull-right">任务情况</span>
        <h5>任务数量</h5>
      </div>
      <div class="ibox-content">
        <el-row :gutter="20">
          <el-col :md="8">
            <div class="big-num no-margins">私人定制日课情况</div>
            <div class="font-bold text-navy m-t">私人定制 {{ d.siren_making }} <small>制作中</small></div>
          </el-col>
          <el-col :md="8">
            <div class="big-num no-margins">吉宅设计日课情况</div>
            <div class="font-bold text-navy m-t">吉宅设计 {{ d.jizhai_making }} <small>正在设计</small></div>
          </el-col>
          <el-col :md="8">
            <div class="big-num no-margins">自动择日日课情况</div>
            <div class="font-bold text-danger m-t">已制作至 {{ d.dateriqi_latest }}</div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 财务情况 -->
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>财务情况</h5>
      </div>
      <div class="ibox-content">
        <el-row :gutter="20">
          <el-col :md="6">
            <div class="big-num no-margins">总收入</div>
            <div class="font-bold text-navy m-t">总收入 {{ d.income_total }}</div>
          </el-col>
          <el-col :md="6">
            <div class="big-num no-margins">会员收入</div>
            <div class="font-bold text-navy m-t">会员收入 {{ d.income_member }}</div>
          </el-col>
          <el-col :md="6">
            <div class="big-num no-margins">私人定制收入</div>
            <div class="font-bold text-danger m-t">私人定制收入 {{ d.income_siren }}</div>
          </el-col>
          <el-col :md="6">
            <div class="big-num no-margins">自动择日收入</div>
            <div class="font-bold text-navy m-t">自动择日收入 {{ d.income_auto }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { systemApi } from '../api/business'

export default {
  name: 'AdminDashboard',
  data () {
    return {
      d: {
        users_total: 0,
        users_vip: 0,
        users_normal: 0,
        siren_making: 0,
        jizhai_making: 0,
        dateriqi_latest: '—',
        income_total: 0,
        income_member: 0,
        income_siren: 0,
        income_auto: 0
      }
    }
  },
  async created () {
    try {
      this.d = { ...this.d, ...(await systemApi.dashboard()) }
    } catch (e) {
      this.$message.error(e.uiMessage || e.message)
    }
  }
}
</script>
